import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { Link } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import { withStyles } from "@material-ui/core";
import { Cookies } from "react-cookie";
import { Alert, AlertTitle } from "@material-ui/lab";
import { Redirect } from "react-router-dom";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import JDate from "jalali-date";
import { $POST, $post } from "./../func";
import Switch from "@material-ui/core/Switch";
import Snackbar from "@material-ui/core/Snackbar";
import * as constants from "../constants";
import Divider from "@material-ui/core/Divider";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Moment from "moment";
import NumberFormat from "react-number-format";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";

import Collapse from "@material-ui/core/Collapse";
import Avatar from "@material-ui/core/Avatar";

import "react-modern-calendar-datepicker/lib/DatePicker.css";
import Calendar from "react-modern-calendar-datepicker";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import FloatingLabelInput from "./FloatingLabelInput";
import Fab from "@material-ui/core/Fab";
import VoiceOverOffIcon from "@material-ui/icons/VoiceOverOff";
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver";
import CloseIcon from "@material-ui/icons/Close";
import CheckIcon from "@material-ui/icons/Check";
import Select from "react-select";

import ImageUploader from "react-images-upload";
import LinearProgress from "@material-ui/core/LinearProgress";

import ReactHTMLTableToExcel from "react-html-table-to-excel";

import { make_cols } from "./MakeColumns";

const styles = (theme) => ({
      mintaraz: {
            display: "flex",
            [theme.breakpoints.up("sm")]: {
                  display: "none",
            },
      },
      maxtaraz: {
            display: "none",
            [theme.breakpoints.up("sm")]: {
                  display: "flex",
            },
      },
      btnsearch: {
            cursor: "pointer",
            [theme.breakpoints.up("md")]: {
                  width: "120px",
                  height: "40px",
                  fontSize: "15px",
            },
            width: "80px",
            height: "30px",
            fontSize: "13px",
            color: "white",
            backgroundColor: "#41589f",
            //  marginRight:'200px',
            //  marginLeft:'200px',
            marginTop: "30px",
            marginBottom: "10px",
            borderRadius: "4px",
            border: "1px solid #41589f",
      },
      paperrtl: {
            marginTop: theme.spacing(0),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
      },
      paper: {
            display: "flex",
            flexWrap: "wrap",
            "& > *": {
                  margin: theme.spacing(1),
                  width: theme.spacing(20),
            },
      },
      root: {
            width: "100%",
            margin: "15px",
            padding: "8px",
            direction: "rtl",
      },
      container: {
            maxHeight: 400,
      },
      large: {
            width: theme.spacing(10),
            height: theme.spacing(10),
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },
});

class ChangeReportFinansialWallet extends Component {
      cookies = new Cookies();
      temp333;
      constructor(props) {
            super(props);
            this.state = {
                  redirect: false,
                  errstr: "",
                  errstatus: false,
                  okstatus: false,
                  requestinfos: [],
                  requestinfofilter: [],
                  rowsPerPage: 10,
                  page: 0,

                  WalletUser: null,
                  orderBy: "user_wallet_id",
                  order: "desc",
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  newFinancialDoc: true,
                  search: false,
                  WalletUserMaxDate: "",
                  WalletUserMinDate: "",
                  WalletUserMaxAmount: "",
                  WalletUserMinAmount: "",
                  user_wallet_amount: "",
                  cntPay: "",
                  sumPay: "",
                  file: {},
                  arrayPay: [],
                  documentcount: 0,
                  sumtaraz: 0,
            };
      }

      setSelectedDayMax = (event) => {
            this.setState({ WalletUserMaxDate: event }, () => {});
      };

      clearDeyMax = (event) => {
            this.setState({ WalletUserMaxDate: "" }, () => {});
      };

      setSelectedDayMin = (event) => {
            this.setState({ WalletUserMinDate: event }, () => {});
      };

      clearDeyMin = (event) => {
            this.setState({ WalletUserMinDate: "" }, () => {});
      };

      handleChangeFinancialDocCode = (event) => {
            this.setState({ user_wallet_amount: event.target.value });
      };

      handleChangeMaxAmount = (event) => {
            this.setState({ WalletUserMaxAmount: event }, () => {});
      };

      handleChangeMinAmount = (event) => {
            this.setState({ WalletUserMinAmount: event }, () => {});
      };

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false });
      };

      handleSelectRows = (row2) => {
            this.setState(
                {
                      WalletUser: row2,
                      newFinancialDoc: false,
                      user_wallet_amount: row2.user_wallet_amount,
                },
                () => {}
            );
      };

      newFinancialDoc = (event) => {
            this.setState({
                  WalletUser: null,
                  newFinancialDoc: true,
                  WalletUserMaxDate: "",
                  WalletUserMinDate: "",
                  user_wallet_amount: "",
                  WalletUserMaxAmount: "",
                  WalletUserMinAmount: "",
            });
      };

      // ---------------------------------------------------------------------------------------------------------
      async componentDidMount() {
            if (this.cookies.get("employee_token_str")) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  });
                  var self = this;
                  const response = await $POST(`employeelogin?command=checkemployeelogin`);
                  const arr = response.data;
                  if (response.status == 200) {
                        if (arr.result === "ok") {
                              self.getFinancialDocPaing();
                        } else if (arr.result === "error") {
                              self.setState({ redirect: true });
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        });
                  }
            } else {
                  this.setState({ redirect: true });
            }
      }

      // -------------------------------------------------------------------------------------------------------------------
      async getFinancialDocPaing() {
            const { rowsPerPage, page } = this.state;

            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            });
            var self = this;
            const response = await $POST(
                `reportfinancial?command=get_user_wallet&limit=${rowsPerPage}&offset=${
                    page * rowsPerPage
                }`
            );
            const response2 = await $POST(`reportfinancial2?command=get_alluser`);
            const newoptions = [{ value: "0", label: "همه کاربران" }];
            for (let i = 0; i < response2.data.data.length; i++) {
                  newoptions.push({
                        value: response2.data.data[i].user_id,
                        label:
                            response2.data.data[i].user_mobile +
                            "-" +
                            response2.data.data[i].user_name,
                  });
            }
            console.log(newoptions, "response2");
            const arr = response.data;
            if (response.status == 200) {
                  console.log(arr);
                  if (arr.result === "ok") {
                        var State = [{ value: "0", label: "همه انواع کاربر" }];
                        var State2 = [{ value: "0", label: "همه کاربران" }];
                        var State3 = [{ value: "0", label: "همه عملیات ها" }];
                        var State4 = [{ value: "0", label: "انواع واریز ها" }];
                        for (var k = 0; k < arr.data.length; k++) {
                              var toFind = arr.data[k].marketer_mode_id;
                              var filtered = State.filter(function (el) {
                                    return el.value === toFind;
                              });
                              if (filtered.length === 0) {
                                    State.push({
                                          value: arr.data[k].marketer_mode_id,
                                          label: arr.data[k].marketer_mode_namefa,
                                    });
                              }

                              toFind = arr.data[k].user_wallet_user_id;
                              filtered = State2.filter(function (el) {
                                    return el.value === toFind;
                              });
                              if (filtered.length === 0) {
                                    State2.push({
                                          value: arr.data[k].user_wallet_user_id,
                                          label:
                                              arr.data[k].user_name +
                                              " " +
                                              arr.data[k].user_family +
                                              "-" +
                                              arr.data[k].user_mobile,
                                    });
                              }

                              toFind = arr.data[k].user_wallet_mode_id;
                              filtered = State3.filter(function (el) {
                                    return el.value === toFind;
                              });
                              if (filtered.length === 0) {
                                    State3.push({
                                          value: arr.data[k].user_wallet_mode_id,
                                          label: arr.data[k].user_wallet_mode,
                                    });
                              }

                              toFind = arr.data[k].user_wallet_gift_id;
                              filtered = State4.filter(function (el) {
                                    return el.value === toFind;
                              });
                              if (filtered.length === 0) {
                                    State4.push({
                                          value: arr.data[k].user_wallet_gift_id,
                                          label: arr.data[k].user_wallet_gift,
                                    });
                              }
                        }
                        console.log(State2, "State2");
                        self.setState(
                            {
                                  requestinfos: arr.data,
                                  requestinfofilter: arr.data,
                                  optionMarketingMode: State,
                                  selectedMarketingMode: State[0],
                                  optionWalletMode: State3,
                                  selectedWalletMode: State3[0],
                                  optionWalletGift: State4,
                                  selectedWalletGift: State4[0],
                                  optionUser: newoptions,
                                  selectedUser: State2[0],
                                  arrCount: arr.cnt,
                            },
                            () => {
                                  self.filterList();
                            }
                        );
                  } else if (arr.result === "error") {
                  }
                  self.props.props.props.dispatch({
                        type: "WITEHIDE",
                  });
            }
      }

      // ---------------------------------------------------------------------------------------------------------------------

      modifyWallet = async () => {
            const {} = this.state;
            const { user_wallet_amount, WalletUser } = this.state;
            if (user_wallet_amount !== "" && user_wallet_amount !== null) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  });

                  var self = this;
                  const response = await $POST(
                      `reportfinancial?command=modify_user_wallet&user_wallet_id=${WalletUser.user_wallet_id}&user_wallet_amount=${user_wallet_amount}`
                  );
                  const arr = response.data;
                  if (response.status == 200) {
                        console.log(arr);
                        if (arr.result === "ok") {
                              self.setState({
                                    snackstr: arr.desc,
                                    showSnack: true,
                                    snackMode: "success",
                              });
                              //self.setState({ redirect: true })
                              self.getFinancialDocPaing();
                              self.newFinancialDoc();
                        } else if (arr.result === "error") {
                              self.setState({
                                    snackstr: arr.desc,
                                    showSnack: true,
                                    snackMode: "error",
                              });
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        });
                  }
            } else {
                  this.setState({
                        snackstr: "لطفا مشخصات کد رهگیری پرداخت  را وارد نمایید",
                        showSnack: true,
                        snackMode: "error",
                  });
            }
      };

      // -------------------------------------------------------------------------------------------------------------------
      deleteWallet = async () => {
            const {} = this.state;
            const { user_wallet_amount, WalletUser } = this.state;
            if (user_wallet_amount !== "" && user_wallet_amount !== null) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  });

                  var self = this;
                  const response = await $POST(
                      `reportfinancial?command=delete_user_wallet&user_wallet_id=${WalletUser.user_wallet_id}`
                  );
                  const arr = response.data;
                  if (response.status == 200) {
                        console.log(arr);
                        if (arr.result === "ok") {
                              self.setState({
                                    snackstr: arr.desc,
                                    showSnack: true,
                                    snackMode: "success",
                              });
                              //self.setState({ redirect: true })
                              self.getFinancialDocPaing();
                              self.newFinancialDoc();
                        } else if (arr.result === "error") {
                              self.setState({
                                    snackstr: arr.desc,
                                    showSnack: true,
                                    snackMode: "error",
                              });
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        });
                  }
            } else {
                  this.setState({
                        snackstr: "لطفا مشخصات کد رهگیری پرداخت  را وارد نمایید",
                        showSnack: true,
                        snackMode: "error",
                  });
            }
      };

      handleUser = (selectedUser) => {
            this.setState({ selectedUser: selectedUser }, () => {});
      };

      handleMarketingMode = (selectedMarketingMode) => {
            this.setState({ selectedMarketingMode: selectedMarketingMode }, () => {});
      };

      handleWalletMode = (selectedWalletMode) => {
            this.setState({ selectedWalletMode: selectedWalletMode }, () => {});
      };

      handleWalletGift = (selectedWalletGift) => {
            this.setState({ selectedWalletGift: selectedWalletGift }, () => {});
      };
      // ************************************************************************************************************************
      // ************************************************************************************************************************
      // ************************************************************************************************************************
      filterList = async () => {
            const {
                  WalletUserMaxAmount,
                  WalletUserMinAmount,
                  requestinfos,
                  selectedUser,
                  selectedMarketingMode,
                  selectedWalletMode,
                  selectedWalletGift,
                  WalletUserMinDate,
                  WalletUserMaxDate,
                  page,
                  rowsPerPage,
            } = this.state;

            const requestinfoscopy = [...requestinfos];

            this.setState({ search: true });

            var timeStampMax = parseInt(
                Moment(
                    JDate.toGregorian(
                        WalletUserMaxDate.year,
                        WalletUserMaxDate.month,
                        WalletUserMaxDate.day
                    )
                ).format("x"),
                0
            );

            var timeStampMin = parseInt(
                Moment(
                    JDate.toGregorian(
                        WalletUserMinDate.year,
                        WalletUserMinDate.month,
                        WalletUserMinDate.day
                    )
                ).format("x"),
                0
            );

            var maxdate = Moment(timeStampMax).format("YYYY-MM-DD");
            var mindate = Moment(timeStampMin).format("YYYY-MM-DD");
            const modename =
                selectedWalletMode.value == "2"
                    ? "add"
                    : selectedWalletMode.value == "1"
                    ? "get"
                    : "";

            console.log(this.state, "eeeeeee");
            const response = await $POST(
                `reportfinancial2?command=get_user_wallet&user_wallet_user_id=${
                    selectedUser.value
                }&marketer_mode_id=${
                    selectedMarketingMode.value
                }&start_user_wallet_timestamp=${
                    typeof this.state.WalletUserMinDate == "object" ? mindate : ""
                }&end_user_wallet_timestamp=${
                    typeof this.state.WalletUserMaxDate == "object" ? maxdate : ""
                }&start_user_wallet_amount=${WalletUserMinAmount}&end_user_wallet_amount=${WalletUserMaxAmount}&user_wallet_mode_id=${modename}&limit=${rowsPerPage}&offset=${
                    page * rowsPerPage
                }`
            );

            this.setState(
                {
                      requestinfofilter: response.data.data,
                      sumPay: response.data.sum,
                      documentcount: response.data.cnt,
                      sumtaraz: response.data.sumtraz,
                },
                () => {}
            );
      };

      createSortHandler = (field) => {
            if (this.state.orderBy === field) {
                  if (this.state.order === "asc") {
                        this.setState({ order: "desc" });
                  } else {
                        this.setState({ order: "asc" });
                  }
            } else {
                  this.setState({ orderBy: field, order: "asc" });
            }
            var arraytemp = [],
                i,
                j,
                temp,
                a,
                b;
            arraytemp = this.state.requestinfofilter;
            for (i = 0; i < arraytemp.length; i++) {
                  for (j = 0; j < arraytemp.length - 1; j++) {
                        a = arraytemp[j];
                        b = arraytemp[j + 1];
                        if (a[field] < b[field] && this.state.order === "asc") {
                              temp = arraytemp[j];
                              arraytemp[j] = arraytemp[j + 1];
                              arraytemp[j + 1] = temp;
                        } else if (a[field] > b[field] && this.state.order === "desc") {
                              temp = arraytemp[j];
                              arraytemp[j] = arraytemp[j + 1];
                              arraytemp[j + 1] = temp;
                        }
                  }
            }
      };

      handleChangeRowsPerPage = (event) => {
            if (this.state.search) {
                  this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 });

                  this.filterList();
            } else {
                  this.setState(
                      { rowsPerPage: parseInt(event.target.value), page: 0 },
                      () => {
                            this.getFinancialDocPaing();
                      }
                  );
            }
      };

      handleChangePage = (event, number) => {
            if (this.state.search) {
                  this.setState(this.setState({ page: parseInt(number, 0) }));

                  this.filterList();
            } else {
                  this.setState({ page: parseInt(number, 0) }, () => {
                        this.getFinancialDocPaing();
                  });
            }
      };

      renderCustomInputMax = ({ ref }) => (
          <OutlinedInput
              readOnly
              ref={ref} // necessary
              placeholder="انتخاب تاریخ سند"
              style={{
                    fontSize: "13px",
                    direction: "ltr",
              }}
              value={
                    this.state.WalletUserMaxDate.year
                        ? this.state.WalletUserMaxDate.year +
                        "/" +
                        this.state.WalletUserMaxDate.month +
                        "/" +
                        this.state.WalletUserMaxDate.day
                        : ""
              }
              className="my-custom-input-class" // a styling class
              endAdornment={
                    <InputAdornment position="end">
                          <IconButton onClick={this.clearDeyMax}>
                                <HighlightOffIcon />
                          </IconButton>
                    </InputAdornment>
              }
          />
      );

      renderCustomInputMin = ({ ref }) => (
          <OutlinedInput
              readOnly
              ref={ref} // necessary
              placeholder="انتخاب تاریخ سند"
              style={{
                    fontSize: "13px",
                    direction: "ltr",
              }}
              value={
                    this.state.WalletUserMinDate.year
                        ? this.state.WalletUserMinDate.year +
                        "/" +
                        this.state.WalletUserMinDate.month +
                        "/" +
                        this.state.WalletUserMinDate.day
                        : ""
              }
              className="my-custom-input-class" // a styling class
              endAdornment={
                    <InputAdornment position="end">
                          <IconButton onClick={this.clearDeyMin}>
                                <HighlightOffIcon />
                          </IconButton>
                    </InputAdornment>
              }
          />
      );

      render() {
            const { classes } = this.props;
            const {
                  sumPay,
                  arrayPay,
                  WalletUserMaxDate,
                  WalletUserMinDate,
                  user_wallet_amount,
                  WalletUserMaxAmount,
                  WalletUserMinAmount,
                  optionUser,
                  selectedUser,
                  optionMarketingMode,
                  selectedMarketingMode,
                  optionWalletMode,
                  selectedWalletMode,
                  optionWalletGift,
                  selectedWalletGift,
                  WalletUser,
                  snackMode,
                  snackstr,
                  showSnack,
                  newFinancialDoc,
                  order,
                  orderBy,
                  okstatus,
                  errstr,
                  redirect,
                  requestinfofilter,
                  rowsPerPage,
                  page,
                  arrCount,
                  sumtaraz,
            } = this.state;
            if (redirect) {
                  return <Redirect to="/" />;
            } else {
                  return (
                      <div
                          className={classes.paperrtl}
                          dir="ltr"
                      >
                            <Snackbar
                                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                onClose={this.handleClickcloseTasckBar}
                                open={showSnack}
                                autoHideDuration={10000}
                            >
                                  <Alert severity={snackMode}>{snackstr}</Alert>
                            </Snackbar>
                            <Grid container spacing={3}>
                                  <Grid item xs={12}>
                                        <Container component="main" maxWidth="lg">
                                              <Paper elevation={4} className={classes.root}>
                                                    <Grid container spacing={3}>
                                                          <Grid item xs={6}>
                                                                <div style={{ width: "100%", textAlign: "center" }}>
                                                                      <Typography variant="h7">
                                                                            {"تاریخ عملیات بزرگتر از"}
                                                                            <Calendar
                                                                                renderInput={this.renderCustomInputMin} // render a custom input
                                                                                value={WalletUserMinDate}
                                                                                onChange={this.setSelectedDayMin}
                                                                                locale="fa"
                                                                                shouldHighlightWeekends
                                                                            />
                                                                      </Typography>
                                                                </div>
                                                          </Grid>
                                                          <Grid item xs={6}>
                                                                <div style={{ width: "100%", textAlign: "center" }}>
                                                                      <Typography variant="h7">
                                                                            {"تاریخ عملیات کوچیکتر از"}
                                                                            <Calendar
                                                                                renderInput={this.renderCustomInputMax} // render a custom input
                                                                                value={WalletUserMaxDate}
                                                                                onChange={this.setSelectedDayMax}
                                                                                locale="fa"
                                                                                shouldHighlightWeekends
                                                                            />
                                                                      </Typography>
                                                                </div>
                                                          </Grid>
                                                          <Grid item xs={6}>
                                                                <FloatingLabelInput
                                                                    type="currency"
                                                                    placeholder="حداقل مبلغ"
                                                                    handleInputt={this.handleChangeMinAmount}
                                                                    value={WalletUserMinAmount}
                                                                />
                                                          </Grid>
                                                          <Grid item xs={6}>
                                                                <FloatingLabelInput
                                                                    type="currency"
                                                                    placeholder="حداکثر مبلغ"
                                                                    handleInputt={this.handleChangeMaxAmount}
                                                                    value={WalletUserMaxAmount}
                                                                />
                                                          </Grid>

                                                          <Grid item xs={6}>
                                                                <div>
                                                                      <label className="on">نوع کاربر</label>
                                                                      <Select
                                                                          isSearchable={true}
                                                                          className="adapter-txtsize"
                                                                          placeholder={"نوع کاربر"}
                                                                          value={selectedMarketingMode}
                                                                          onChange={this.handleMarketingMode}
                                                                          options={optionMarketingMode}
                                                                      />
                                                                </div>
                                                          </Grid>

                                                          <Grid item xs={6}>
                                                                <div>
                                                                      <label className="on">نوع عملیات</label>
                                                                      <Select
                                                                          isSearchable={true}
                                                                          className="adapter-txtsize"
                                                                          placeholder={"نوع عملیات"}
                                                                          value={selectedWalletMode}
                                                                          onChange={this.handleWalletMode}
                                                                          options={optionWalletMode}
                                                                      />
                                                                </div>
                                                          </Grid>

                                                          <Grid item xs={6}>
                                                                <div>
                                                                      <label className="on">نوع پرداخت</label>
                                                                      <Select
                                                                          isSearchable={true}
                                                                          className="adapter-txtsize"
                                                                          placeholder={"نوع پرداخت"}
                                                                          value={selectedWalletGift}
                                                                          onChange={this.handleWalletGift}
                                                                          options={optionWalletGift}
                                                                      />
                                                                </div>
                                                          </Grid>

                                                          <Grid item xs={6}>
                                                                <div>
                                                                      <label className="on">کاربر</label>
                                                                      <Select
                                                                          isSearchable={true}
                                                                          className="adapter-txtsize"
                                                                          placeholder={"کاربر"}
                                                                          value={selectedUser}
                                                                          onChange={this.handleUser}
                                                                          options={optionUser}
                                                                      />
                                                                </div>
                                                          </Grid>
                                                          <Grid item xs={12}>
                                                                <Divider />
                                                          </Grid>
                                                          <Grid item xs={4}>
                                                                <Typography variant="h6">
                                                                      {"تعداد سند: "}
                                                                      {this.state.documentcount}
                                                                </Typography>
                                                          </Grid>

                                                          <Grid item xs={4}>
                                                                <Typography variant="h6">
                                                                      {"جمع اسناد: "}
                                                                      <NumberFormat
                                                                          displayType={"text"}
                                                                          value={sumPay}
                                                                          thousandSeparator={true}
                                                                          prefix={" ریال"}
                                                                      />
                                                                </Typography>
                                                          </Grid>
                                                          <Grid className={classes.maxtaraz} item xs={4}>
                                                                <Typography variant="h6">
                                                                      {"جمع تراز: "}
                                                                      <NumberFormat
                                                                          displayType={"text"}
                                                                          value={sumtaraz}
                                                                          thousandSeparator={true}
                                                                          prefix={" ریال"}
                                                                      />
                                                                </Typography>
                                                          </Grid>
                                                    </Grid>
                                                    <Grid className={classes.mintaraz} item xs={4}>
                                                          <Typography variant="h6">
                                                                {"جمع تراز: "}
                                                                <NumberFormat
                                                                    displayType={"text"}
                                                                    value={sumtaraz}
                                                                    thousandSeparator={true}
                                                                    prefix={" ریال"}
                                                                />
                                                          </Typography>
                                                    </Grid>
                                                    <div
                                                        style={{
                                                              width: "100%",
                                                              display: "flex",
                                                              justifyContent: "center",
                                                              alignItems: "center",
                                                        }}
                                                    >
                                                          <button
                                                              onClick={() => this.filterList()}
                                                              className={classes.btnsearch}
                                                          >
                                                                جستجو
                                                          </button>
                                                    </div>
                                              </Paper>
                                        </Container>
                                  </Grid>

                                  <Grid item xs={12}>
                                        {newFinancialDoc || WalletUser === null ? null : (
                                            <Container component="main" maxWidth="lg">
                                                  <Paper elevation={4} className={classes.root}>
                                                        <Grid container spacing={3}>
                                                              <Grid item xs={12}>
                                                                    <Typography variant="h6">
                                                                          {"سند مالی در حال پرداخت"}
                                                                    </Typography>
                                                              </Grid>

                                                              <Grid item xs={3}>
                                                                    <Typography align="center" variant="h7">
                                                                          {"شماره سند:  " + WalletUser["user_wallet_id"]}
                                                                    </Typography>
                                                              </Grid>
                                                              <Grid item xs={3}>
                                                                    <Typography align="center" variant="h7">
                                                                          {"مبلغ عملیات:  "}
                                                                          <NumberFormat
                                                                              displayType={"text"}
                                                                              value={WalletUser["user_wallet_amount"]}
                                                                              thousandSeparator={true}
                                                                              prefix={" ریال"}
                                                                          />
                                                                    </Typography>
                                                              </Grid>
                                                              <Grid item xs={2}>
                                                                    <Typography align="center" variant="h7">
                                                                          {"نوع کاربر:  " + WalletUser["marketer_mode_namefa"]}
                                                                    </Typography>
                                                              </Grid>

                                                              <Grid item xs={4}>
                                                                    <Typography align="center" variant="h7">
                                                                          {"نام کاربر:  " +
                                                                          WalletUser["user_name"] +
                                                                          " " +
                                                                          WalletUser["user_family"] +
                                                                          " -همراه:" +
                                                                          WalletUser["user_mobile"]}
                                                                    </Typography>
                                                              </Grid>

                                                              <Grid item xs={3}>
                                                                    <Typography align="center" variant="h7">
                                                                          {"نوع عملیات:  " + WalletUser["user_wallet_mode"]}
                                                                    </Typography>
                                                              </Grid>

                                                              <Grid item xs={3}>
                                                                    <Typography variant="h7">
                                                                          {"تاریخ عملیات: "}
                                                                          {new JDate(
                                                                              new Date(
                                                                                  parseInt(
                                                                                      Moment(
                                                                                          WalletUser["user_wallet_timestamp"],
                                                                                          "YYYY-M-D HH:mm:ss"
                                                                                      ).format("x")
                                                                                  )
                                                                              )
                                                                          ).format("YYYY/MM/DD") +
                                                                          " " +
                                                                          Moment(
                                                                              WalletUser["user_wallet_timestamp"],
                                                                              "YYYY-M-D HH:mm:ss"
                                                                          ).format("HH:mm:ss")}
                                                                    </Typography>
                                                              </Grid>

                                                              <Grid item xs={6}>
                                                                    <FloatingLabelInput
                                                                        placeholder="اصلاح مبلغ"
                                                                        handleInputt={this.handleChangeFinancialDocCode}
                                                                        value={user_wallet_amount}
                                                                    />
                                                              </Grid>

                                                              <Grid item xs={6}>
                                                                    <div style={{ width: "100%", textAlign: "right" }}>
                                                                          <Button
                                                                              variant="outlined"
                                                                              color="primary"
                                                                              onClick={(e) => {
                                                                                    this.modifyWallet();
                                                                              }}
                                                                          >
                                                                                {"اصلاح مبلغ"}
                                                                          </Button>
                                                                          {"      "}
                                                                          <Button
                                                                              variant="outlined"
                                                                              color="primary"
                                                                              onClick={(e) => {
                                                                                    this.deleteWallet();
                                                                              }}
                                                                          >
                                                                                {"حذف رکورد"}
                                                                          </Button>
                                                                    </div>
                                                              </Grid>
                                                        </Grid>

                                                        <Grid item xs={12}>
                                                              <div style={{ width: "100%", textAlign: "left" }}>
                                                                    <Button
                                                                        variant="outlined"
                                                                        color="primary"
                                                                        onClick={this.newFinancialDoc}
                                                                    >
                                                                          {"بستن"}
                                                                    </Button>
                                                              </div>
                                                        </Grid>
                                                  </Paper>
                                            </Container>
                                        )}
                                  </Grid>
                                  <Grid item xs={12}>
                                        <Container maxWidth="lg">
                                              <Paper className={classes.root}>
                                                    <ReactHTMLTableToExcel
                                                        id="test-table-xls-button"
                                                        className="download-table-xls-button"
                                                        table="table-to-xls"
                                                        filename="tablexls"
                                                        sheet="tablexls"
                                                        buttonText="Download as XLS"
                                                    />

                                                    <TableContainer dir="rtl">
                                                          <Table id="table-to-xls" aria-label="sticky table">
                                                                <TableHead>
                                                                      <TableRow>
                                                                            <TableCell
                                                                                key={"user_wallet_id"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 20 }}
                                                                                sortDirection={
                                                                                      orderBy === "user_wallet_id" ? order : false
                                                                                }
                                                                            >
                                                                                  {"آیدی سند"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "user_wallet_id"}
                                                                                      direction={
                                                                                            orderBy === "user_wallet_id" ? order : "asc"
                                                                                      }
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("user_wallet_id");
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>
                                                                            <TableCell
                                                                                key={"marketer_mode_id"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 60 }}
                                                                            >
                                                                                  {"نوع کاربر"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "marketer_mode_id"}
                                                                                      direction={
                                                                                            orderBy === "marketer_mode_id" ? order : "asc"
                                                                                      }
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("marketer_mode_id");
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>
                                                                            <TableCell
                                                                                key={"user_name"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 60 }}
                                                                            >
                                                                                  {"نام کاربر"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "user_name"}
                                                                                      direction={
                                                                                            orderBy === "user_name" ? order : "asc"
                                                                                      }
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("user_name");
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>
                                                                            <TableCell
                                                                                key={"user_mobile"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 60 }}
                                                                            >
                                                                                  {"همراه کاربر"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "user_mobile"}
                                                                                      direction={
                                                                                            orderBy === "user_mobile" ? order : "asc"
                                                                                      }
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("user_mobile");
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>
                                                                            <TableCell
                                                                                key={"user_wallet_amount"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 60 }}
                                                                            >
                                                                                  {"مبلغ"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "user_wallet_amount"}
                                                                                      direction={
                                                                                            orderBy === "user_wallet_amount" ? order : "asc"
                                                                                      }
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("user_wallet_amount");
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"user_wallet_timestamp"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 60 }}
                                                                            >
                                                                                  {"تاریخ عملیات"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "user_wallet_timestamp"}
                                                                                      direction={
                                                                                            orderBy === "user_wallet_timestamp"
                                                                                                ? order
                                                                                                : "asc"
                                                                                      }
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("user_wallet_timestamp");
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"user_wallet_mode_id"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 60 }}
                                                                            >
                                                                                  {"نوع عملیات"}
                                                                                  <TableSortLabel
                                                                                      active={
                                                                                            orderBy ===
                                                                                            "user_wallet_gift_iduser_wallet_gift_id"
                                                                                      }
                                                                                      direction={
                                                                                            orderBy === "user_wallet_mode_id"
                                                                                                ? order
                                                                                                : "asc"
                                                                                      }
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("user_wallet_mode_id");
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"user_wallet_gift_id"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 60 }}
                                                                            >
                                                                                  {" نوع پرداخت"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "user_wallet_gift_id"}
                                                                                      direction={
                                                                                            orderBy === "user_wallet_gift_id"
                                                                                                ? order
                                                                                                : "asc"
                                                                                      }
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("user_wallet_gift_id");
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>
                                                                            <TableCell
                                                                                key={"user_wallet_gift_id"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 60 }}
                                                                            >
                                                                                  {" شرح پرداخت"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "user_wallet_detail"}
                                                                                      direction={
                                                                                            orderBy === "user_wallet_detail" ? order : "asc"
                                                                                      }
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("user_wallet_detail");
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>
                                                                      </TableRow>
                                                                </TableHead>

                                                                <TableBody>
                                                                      {requestinfofilter.slice(0, rowsPerPage).map((row) => {
                                                                            return (
                                                                                <TableRow
                                                                                    hover
                                                                                    role="checkbox"
                                                                                    tabIndex={-1}
                                                                                    key={row["user_wallet_id"]}
                                                                                    value={row}
                                                                                    onClick={() => {
                                                                                          this.handleSelectRows(row);
                                                                                    }}
                                                                                >
                                                                                      <TableCell
                                                                                          key={"user_wallet_id"}
                                                                                          align={"center"}
                                                                                      >
                                                                                            {row["user_wallet_id"]}
                                                                                      </TableCell>

                                                                                      <TableCell
                                                                                          key={"marketer_mode_namefa"}
                                                                                          align={"center"}
                                                                                      >
                                                                                            {row["marketer_mode_namefa"]}
                                                                                      </TableCell>

                                                                                      <TableCell key={"user_name"} align={"center"}>
                                                                                            {row["user_name"] + " " + row["user_family"]}
                                                                                      </TableCell>

                                                                                      <TableCell key={"user_mobile"} align={"center"}>
                                                                                            {row["user_mobile"]}
                                                                                      </TableCell>

                                                                                      <TableCell
                                                                                          key={"user_wallet_amount"}
                                                                                          align={"center"}
                                                                                      >
                                                                                            <NumberFormat
                                                                                                displayType={"text"}
                                                                                                value={row["user_wallet_amount"]}
                                                                                                thousandSeparator={true}
                                                                                                prefix={" ریال"}
                                                                                            />
                                                                                      </TableCell>

                                                                                      <TableCell
                                                                                          key={"user_wallet_amount"}
                                                                                          align={"center"}
                                                                                      >
                                                                                            {new JDate(
                                                                                                new Date(
                                                                                                    parseInt(
                                                                                                        Moment(
                                                                                                            row["user_wallet_timestamp"],
                                                                                                            "YYYY-M-D HH:mm:ss"
                                                                                                        ).format("x")
                                                                                                    )
                                                                                                )
                                                                                            ).format("YYYY/MM/DD") +
                                                                                            " " +
                                                                                            Moment(
                                                                                                row["user_wallet_timestamp"],
                                                                                                "YYYY-M-D HH:mm:ss"
                                                                                            ).format("HH:mm:ss")}
                                                                                      </TableCell>

                                                                                      <TableCell
                                                                                          key={"user_wallet_mode_id"}
                                                                                          align={"center"}
                                                                                      >
                                                                                            {row["user_wallet_mode"]}
                                                                                      </TableCell>

                                                                                      <TableCell
                                                                                          key={"user_wallet_gift_id"}
                                                                                          align={"center"}
                                                                                      >
                                                                                            {row["user_wallet_gift"]}
                                                                                      </TableCell>

                                                                                      <TableCell
                                                                                          key={"user_wallet_detail"}
                                                                                          align={"center"}
                                                                                      >
                                                                                            {row["user_wallet_detail"]}
                                                                                      </TableCell>
                                                                                </TableRow>
                                                                            );
                                                                      })}
                                                                </TableBody>
                                                          </Table>
                                                    </TableContainer>
                                                    <TablePagination
                                                        rowsPerPageOptions={[
                                                              10, 25, 100, 1000, 5000, 10000, 100000,
                                                        ]}
                                                        component="div"
                                                        count={arrCount}
                                                        rowsPerPage={rowsPerPage}
                                                        page={page}
                                                        onChangePage={this.handleChangePage}
                                                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                                    />
                                              </Paper>
                                        </Container>
                                  </Grid>
                            </Grid>

                            {okstatus ? (
                                <Alert severity="success">
                                      <AlertTitle>پیام</AlertTitle>
                                      {errstr}
                                </Alert>
                            ) : null}
                      </div>
                  );
            }
      }
}

export default withStyles(styles)(ChangeReportFinansialWallet);
